<template>
	<c-dialog ref="dialog" width="650" @resolve="editHandle">
		<c-form ref="form" unit-width="100%">
			<c-input type="hidden" name="id"></c-input>
			<c-form-item label="位置标识" required tip="位置标识决定小程序端 useType 用途映射，需严格按以下编码：banner=轮播、anpai=暗拍专区、shuma=数码专区、gz=工作机专区、gg=黑马找货、zy=资源机、lj=靓机精选">
				<c-input name="position_code" maxlength="50"></c-input>
			</c-form-item>
			<c-form-item label="位置名称" required>
				<c-input name="position_name" maxlength="100"></c-input>
			</c-form-item>
			<c-form-item label="广告尺寸" tip="单位px，选填">
				<c-input name="width" type="number" style="width:120px;" placeholder="宽"></c-input>
				<span style="margin:0 8px;">x</span>
				<c-input name="height" type="number" style="width:120px;" placeholder="高"></c-input>
			</c-form-item>
			<c-form-item label="排序号" tip="数字越小越靠前">
				<c-input name="sort_no" type="number"></c-input>
			</c-form-item>
			<c-form-item label="备注">
				<c-input name="remark" type="textarea" maxlength="500"></c-input>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
export default {
	data() {
		return {
			editState: false
		}
	},

	methods: {
		/*********打开编辑框，初始化**********/
		open(data) {
			this.editState = false;
			this.$refs.form.clear();
			if (data) {
				this.editState = true;
				this.$refs.form.set(data);
			}
			// 填充form表单
			this.$refs.dialog.open({
				title: data ? '编辑广告位' : '新增广告位'
			});
		},

		/*******新增、编辑提交处理方法********/
		editHandle(stop, next) {
			stop();
			this.$refs.form.submit({
				url: this.editState ? '/mall/ad_position/edit' : '/mall/ad_position/add',
				rule: {
					position_code: '请输入位置标识',
					position_name: '请输入位置名称'
				},
				dataFormatter: data => {
					return data;
				},
				success: (data, res) => {
					next();
					if (this.editState) {
						this.$message({
							message: '编辑成功',
							type: 'success'
						});
					} else {
						this.$message({
							message: '新增成功',
							type: 'success'
						});
					}
					this.$emit('resolve');
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
</style>
